import axios from 'axios'
import {asResponse} from '../util'
import {mutate} from 'swr'
import {omit} from 'lodash'

export const ENVIRONMENT_SWR_KEY = ({environmentId}) => [
  '/bff/environments/${environmentId}?load=resources[{"options":{"sort": {"weight":-1}}}]',
  environmentId
]

export const getEnvironment = async (url, environmentId) => {
  if (!environmentId) {
    return {
      environment: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${environmentId}', environmentId)))
  return {
    environment: resp.data
  }
}

export const getEnvironmentById = async (environmentId) => {
  const resp = await asResponse(axios.get(`/bff/environments/${environmentId}`))
  return resp.data
}

export const mutateEnvironment = async function () {
  let args = Array.from(arguments)
  const environmentId = args[args.length - 1]
  const key = ENVIRONMENT_SWR_KEY({environmentId})
  args = [key, ...args]
  return mutate.apply(this, args)
}

export const upsertEnvironment = async (environment) => {
  const verb = environment.id ? 'put' : 'post'
  const path = environment.id ? `/bff/environments/${environment.id}` : `/bff/environments`
  environment = omit(environment, ['resources'])
  const resp = await asResponse(axios[verb](path, environment))
  return resp.data
}

export const removeEnvironment = async (environmentId) => {
  return axios.delete(`/bff/environments/${environmentId}`)
}

export const archiveEnvironment = async (environmentId) => {
  const resp = await asResponse(axios.post('/bff/environments/archive', {environmentId}))
  return resp.data
}

export const cloneEnvironment = async (environmentId) => {
  const resp = await asResponse(axios.post(`/bff/environments/clone`, {id: environmentId}))
  return resp.data
}
